const VENUES_QUERY_KEY = 'venues';

const VENUE_QUERY_KEY = (id: string): string[] => [VENUES_QUERY_KEY, id];

export { VENUES_QUERY_KEY, VENUE_QUERY_KEY };
